<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>
            17. Potenzial von Zukunftstechnologien nach Größe: "Deep Dive" 1
          </h2>
          <p></p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ChallengeDD2",
  computed: {
    chartOptions() {
      return {
        title: {
          text:
            "Wahrnehmung eines großen bis sehr großen Potenzials in Schlüsseltechnologien nach Organisationsgröße."
        },

        xAxis: {
          categories: ["Sehr klein", "", "", "", "", "", "", "", "Sehr groß"]
        },
        yAxis: {
          title: {
            text: "Prozent der Organisationen"
          }
        },

        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },

        series: [
          {
            name: "Künstliche Intelligenz",
            data: [10.1, 8.9, 9.8, 11.8, 15.2, 16.9, 13.8, 16.9, 27.7]
          },
          {
            name: "Cloud Computing",
            data: [32.9, 34.6, 40.2, 47.5, 49.9, 49.7, 54.1, 53.8, 62.5]
          },
          {
            name: "Virtual Reality",
            data: [14.2, 14.5, 14.6, 16.9, 16.8, 19.4, 21.3, 23.4, 25.4]
          }
        ],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom"
                }
              }
            }
          ]
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
